import Clarity from "@microsoft/clarity";

const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_ID;

export const initClarity = () => {
  if (!CLARITY_PROJECT_ID) {
    console.log("VITE_CLARITY_ID is not configured");
    return;
  }

  Clarity.init(CLARITY_PROJECT_ID);
};

export const setClarityUser = (adminDetail) => {
  if (!CLARITY_PROJECT_ID) {
    // console.log('VITE_CLARITY_ID is not configured');
    return;
  }
  if (!adminDetail?.id) {
    return;
  }

  const userId = String(adminDetail.id);

  const username = adminDetail.loginClientName ?? "Guest";

  const useremail = adminDetail.email ?? "Guest";

  // Identify user
  Clarity.identify(userId, undefined, undefined, userId);

  // Custom properties
  Clarity.setTag("username", username);
  Clarity.setTag("useremail", useremail);
};
